import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Button } from 'components'

const FamilyIntro = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_ 1 padding center-cont">
				<div className="slider">
					<ul>
						<li>
							<i className="icon icon_family_intro01" />
							<h3 className="intro-tit mt_20">함께 거주중인 가족의 정보를 확인하세요!</h3>
							<p className="intro-sub-tit mt_10">
								우리 가족의 만 나이와 띠 뿐만 아니라<br />
								생일 디데이까지 알려드려요!
							</p>
						</li>
						{/* <li>
							<i className="icon icon_family_intro02" />
							<h3 className="intro-tit mt_20">우리 가족의 구성정보를 알 수 있어요!</h3>
							<p className="intro-sub-tit mt_10">
								세대주를 중심으로 우리 가족이 구성된 날짜부터<br />
								구성사유와 현재 등록상태까지!
							</p>
						</li> */}
					</ul>
					<ul className="slider-dots dots-gray" style={{ marginTop: "14rem" }}>
						<li className="active" />
						<li />
					</ul>
				</div>
			</div>
			<div className="padding flex-shrink_0">
				<Button className="btn btn--big">시작하기</Button>
			</div>
		</div>
	)
}

export default FamilyIntro
